jQuery(function( $ ){

  
  //Header addclass on scroll
  $(window).scroll(function() {    
		var scroll = $(window).scrollTop();
	
		if (scroll >= 5) {
			$(".site-header").addClass("shrink");
		} else {
			$(".site-header").removeClass("shrink");
		}
	});
    
  
  //all ext url opens new page
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}
  
  $( ".js-mobile-nav-toggle .icon" ).click(function() {
    $( ".template-index" ).toggleClass( "nav_open" );
  });

  
  /*Dropdown Menu*/
$('.dropdown').click(function () {
        $(this).attr('tabindex', 1).focus();
        $(this).toggleClass('active');
        $(this).find('.dropdown-menu').slideToggle(300);
    });
    $('.dropdown').focusout(function () {
        $(this).removeClass('active');
        $(this).find('.dropdown-menu').slideUp(300);
    });
    $('.dropdown .dropdown-menu li').click(function () {
        $(this).parents('.dropdown').find('span').text($(this).text());
        $(this).parents('.dropdown').find('input').attr('value', $(this).attr('id'));
    });
/*End Dropdown Menu*/

  
   /*CALCULATOR*/
  $( "#Metres" ).click(function() {
    $( ".mtr" ).addClass( "show" ).removeClass( "hide" );
    $( ".ft" ).removeClass( "show" ).addClass("hide");
  });
  
   $( "#Feet" ).click(function() {
    $( ".mtr" ).removeClass( "show" ).addClass("hide");
    $( ".ft" ).removeClass( "hide" ).addClass("show");
  });

  

  
  
$(function(){
            $('#value1, #value2').keyup(function(){
               var value1 = parseFloat($('#value1').val()) || 0;
               var value2 = parseFloat($('#value2').val()) || 0;
               var value3 = (value1 * value2);
               var value4 = (value3 * 44);
               var value5 = (value3 * 4);
              
               var value6 = (value4 / 12);
               var value7 = (value4 / 100);
    		   var value8 = (value4 / 50);
              
               var valstarter = Math.ceil(value6);
               var valpacks = Math.ceil(value7);
               var valpacksfifty = Math.ceil(value7);
         	
              
               $('#podsum_mtr').val(value3 * 44);
               $('#podsum_ft').val(value3 * 4);
               $('#platesum_mtr').val(value4 / 2);
               $('#platesum_ft').val(value5 / 2); 
               $('#starterpacks_need').val(valstarter);
               $('#packs_need').val(valpacks);
               $('#fifty_packs_need').val(valpacksfifty);
          
        
              
                $('.kits').change(function() {
                  if (this.value == 'starter') {
                    $('#starterpacks_need').addClass('show').removeClass('hide');
                    $('#packs_need').removeClass('show').addClass('hide');
                    $('#fifty_packs_need').removeClass('show').addClass('hide');
                    $('.fifty.btn').addClass('hide');
                    $('.twelve.btn').removeClass('hide');
                    $('.hundred.btn').addClass('hide');
                  }
                  else if (this.value == 'pack') {
                    $('#packs_need').addClass('show').removeClass('hide');
                    $('#starterpacks_need').removeClass('show').addClass('hide');
                    $('#fifty_packs_need').removeClass('show').addClass('hide');
                    $('.fifty.btn').addClass('hide');
                    $('.twelve.btn').addClass('hide');
                    $('.hundred.btn').removeClass('hide');
                  }
                  else if (this.value == '50pack') {
                    $('#fifty_packs_need').addClass('show').removeClass('hide');
                    $('#packs_need').removeClass('show').addClass('hide');
                    $('#starterpacks_need').removeClass('show').addClass('hide');
                    $('.fifty.btn').removeClass('hide');
                    $('.twelve.btn').addClass('hide');
                    $('.hundred.btn').addClass('hide');
                  }
                });
              
              
            });
         });
 
  
   /*END OF CALCULATOR*/
  
     /*SINGLE PRODUCT */
  $('.product-single__thumbnails').slick({
  infinite: true,
  slidesToShow: 5,
  slidesToScroll: 5,
    prevArrow: '<i class="fas fa-chevron-left"></i>',
  nextArrow: '<i class="fas fa-chevron-right"></i>'
});
     /*END OF SINGLE PRODUCT*/
  
  
  $('.stamped-summary-actions').insertAfter('stamped-content');
  
});